import(/* webpackMode: "eager" */ "/tmp/8dee03d7c805bcf/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dee03d7c805bcf/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dee03d7c805bcf/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dee03d7c805bcf/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dee03d7c805bcf/components/pages/LegalPage.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dee03d7c805bcf/node_modules/next/dist/client/link.js");
